<template>
  <div class="levelThree">
    <div class="flex">
      <div class="title">分类</div>
      <div
        class="all cp"
        :class="chooseTypeId == '' ? 'active' : ''"
        @click="chooseType('')"
      >
        全部分类
      </div>
      <div class="flex typeDiv">
        <div
          v-for="item in typeList"
          :key="item.id"
          class="typeItemDiv cp"
          :class="chooseTypeId == item.id ? 'active' : ''"
          @click="chooseType(item.id)"
        >
          {{ item.name }}
        </div>
      </div>
    </div>
    <div class="flex">
      <div class="title">商区</div>
      <div
        class="all cp"
        :class="chooseCityId == '' ? 'active' : ''"
        @click="chooseCity('')"
      >
        全部商区
      </div>
      <div class="flex typeDiv">
        <div
          v-for="item in cityList"
          :key="item.id"
          class="typeItemDiv cp"
          :class="chooseCityId == item.id ? 'active' : ''"
          @click="chooseCity(item.id)"
        >
          {{ item.name }}
        </div>
      </div>
    </div>
    <div>机构（{{ total }}）</div>
  </div>
</template>
<script>
import axios from "@/api/config";
import { mapGetters } from "vuex";
export default {
  name: "levelThree-template",
  props: {
    total: Number,
  },
  data() {
    return {
      chooseTypeId: "",
      chooseCityId: "",
      typeList: [],
      cityList: [],
    };
  },
  computed: {
    ...mapGetters(["loginData"]),
  },
  methods: {
    getSubjectTreeList() {
      axios
        .get(`${process.env.BASE_URL}/subjectCourse/getSubjectTreeList?menuId=2`, {})
        .then((res) => {
          this.typeList = res.data;
        });
    },
    getDictionaryListCity() {
      let obj = JSON.stringify({ parentId: "1415494109434540034" });
      axios
        .get(`${process.env.BASE_URL}/dictionary/getDictionaryListByParentId`, {
          params: { parentId: "1415494109434540034" },
        })
        .then((res) => {
          this.cityList = res.data;
        });
    },
    chooseType(val) {
      this.chooseTypeId = val;
      this.$emit("changeType", val);
    },
    chooseCity(val) {
      this.chooseCityId = val;
      this.$emit("changeCity", val);
    },
  },
  mounted() {
    this.getSubjectTreeList();
    this.getDictionaryListCity();
  },
};
</script>
<style scoped>
.levelThree {
  background: #fff;
  padding: 20px;
  box-sizing: border-box;
  margin-bottom: 40px;
}
.typeDiv {
  width: calc(100% - 130px);
  flex-wrap: wrap;
}
.title {
  width: 50px;
}
.all {
  width: 80px;
}
.cp {
  cursor: pointer;
}
.typeItemDiv {
  padding: 0 16px;
  box-sizing: border-box;
  margin-bottom: 10px;
}
.active {
  color: blue;
}
</style>



// WEBPACK FOOTER //
// src/components/onlineSchool/diyTemplate/levelThreeTemplate.vue